<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card class="list-view-item overflow-hidden" :id="`section${item.id}`">
		<template slot="no-body">
			<div class="vx-row item-details no-gutter">
				<!-- IMG COL -->
				<div
					class="vx-col sm:w-2/12 md:w-2/12 w-full item-img-container bg-white flex flex-col items-center justify-center cursor-pointer"
				>
					<vs-icon
						ref="loadableButton"
						:id="`button-with-loading-${item.id}`"
						class="mt-1"
						icon="groups"
						size="80px"
						color="#111350"
					></vs-icon>
					<h6 class="item-name font-semibold">{{ $t("Group.Group") }} N. {{ item.id }}</h6>
				</div>
				<!-- ITEM NAME AND DESC COL -->
				<div class="vx-col sm:w-6/12 md:w-6/12">
					<div class="p-4 pt-6 mb-base">
						<slot name="item-meta">
							<h5 class="item-name font-semibold mb-1 hover:text-primary cursor-pointer">
								{{ item.name }}
							</h5>
							<p class="text-sm mb-3">
								<span class="font-semibold cursor-pointer">{{ item.company_name }}</span>
							</p>
							<p class="item-description text-sm">
								<span class="font-semibold cursor-pointer">{{ $t("Routing.Table.AddedOn") }}:</span>
								{{ item.added_on }}
							</p>
						</slot>
					</div>
				</div>

				<!-- BOTTONS -->
				<div
					class="vx-col sm:w-4/12 md:w-4/12 w-full flex items-center sm:border border-0 border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0"
				>
					<div class="p-4 flex flex-col w-full">
						<div class="my-5">
							<h5 class="font-bold text-center">
								{{ "Total " + $t("Optimization.Optimizations") }}
							</h5>
							<h5 class="font-bold text-center">
								{{ item.total_optimization }}
							</h5>
						</div>
						<!-- SLOT: ACTION BUTTONS -->
						<div class="flex flex-wrap justify-center">
							<!-- SECONDARY BUTTON: MOVE TO CART -->
							<vs-button
								color="success"
								icon-pack="feather"
								icon="icon-check-circle"
								class="ml-1 mr-1"
								:disabled="item.total_finalized <= 0"
								:title="$t('Group.TotalFinalized') + ': ' + item.total_finalized"
								@click.prevent="
									$emit('showOptimizationByStatus', {statu: 'FINALIZED', dataGroup: item})
								"
							></vs-button>
							<vs-button
								color="warning"
								icon-pack="feather"
								icon="icon-refresh-cw"
								class="ml-1 mr-1"
								:disabled="item.total_processing <= 0"
								:title="$t('Group.TotalProcessed') + ': ' + item.total_processing"
								@click.prevent="
									$emit('showOptimizationByStatus', {statu: 'PROCESSING', dataGroup: item})
								"
							></vs-button>
							<vs-button
								color="danger"
								icon-pack="feather"
								icon="icon-alert-circle"
								class="ml-1 mr-1"
								:disabled="item.total_error <= 0"
								:title="$t('Group.TotalErrors') + ': ' + item.total_error"
								@click.prevent="$emit('showOptimizationByStatus', {statu: 'ERROR', dataGroup: item})"
							></vs-button>
						</div>
					</div>
				</div>
			</div>
		</template>
	</vx-card>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			default: {},
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.list-view-item {
	.item-name,
	.item-description {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.item-name {
		-webkit-line-clamp: 2;
	}

	.item-description {
		-webkit-line-clamp: 5;
	}

	.grid-view-img {
		max-width: 100%;
		max-height: 100%;
		width: auto;
		transition: 0.35s;
	}

	&:hover {
		transform: translateY(-5px);
		box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

		.grid-view-img {
			opacity: 0.9;
		}
	}
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.6s ease;
}

.slide-fade-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(-50px);
	opacity: 0;
}
</style>
